<div class="page-container" [testId]="'theme-list-container'">
  <div class="search-section" [testId]="'theme-list-search-section'">
    <div nz-row [nzGutter]="24" class="search-row" [testId]="'theme-list-search-row'">
      <div
        nz-col
        [nzXs]="24"
        [nzSm]="24"
        [nzMd]="8"
        [nzLg]="8"
        class="search-input-container"
        [testId]="'theme-list-search-input-container'"
      >
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'theme-list-search-input-group'">
          <input
            type="text"
            nz-input
            [placeholder]="'theme.list.search-placeholder' | i18n"
            [(ngModel)]="searchKeywords"
            (keyup.enter)="search()"
            [testId]="'theme-list-search-input'"
          />
          <ng-template #suffixIconSearch [testId]="'theme-list-search-icon-template'">
            <i
              nz-icon
              nzType="search"
              (click)="search()"
              nz-tooltip
              [nzTooltipTitle]="'theme.list.search-tooltip' | i18n"
              class="search-icon"
              [testId]="'theme-list-search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <button
          nz-button
          nzType="default"
          (click)="reset()"
          class="reset-button"
          nz-tooltip
          [nzTooltipTitle]="'common.reset' | i18n"
          [testId]="'theme-list-reset-button'"
        >
          <i nz-icon nzType="clear" [testId]="'theme-list-reset-icon'"></i>
        </button>
      </div>
      <div
        nz-col
        [nzXs]="24"
        [nzSm]="8"
        [nzMd]="6"
        [nzLg]="6"
        class="action-buttons"
        [testId]="'theme-list-action-buttons'"
        *ngIf="!selectMode"
      >
        <button nz-button nzType="primary" class="add-button" (click)="goToCreate()" [testId]="'theme-list-add-button'">
          <nz-icon nzType="plus" [testId]="'theme-list-add-icon'" />
          <span class="button-text">{{ 'theme.list.button.add' | i18n }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-section" [testId]="'table-container'">
    <nz-table
      class="content-table"
      nzSize="small"
      [nzScroll]="{ x: '100%', y: 'calc(100vh - 200px)' }"
      [nzData]="listOfData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzLoading]="loading"
      [testId]="'theme-table'"
    >
      <thead [testId]="'table-header'">
        <tr [testId]="'header-row'">
          <th scope="col" nzWidth="60px" nzLeft class="text-center row-number-column" [testId]="'header-serial-number'">{{
            'common.serial-number' | i18n
          }}</th>
          <th scope="col" nzWidth="240px" [testId]="'header-name'">{{ 'theme.list.table.name' | i18n }}</th>
          <th scope="col" nzWidth="340px" [testId]="'header-description'">{{ 'theme.list.table.description' | i18n }}</th>
          <th scope="col" nzWidth="120px" [testId]="'header-status'">{{ 'theme.list.table.status' | i18n }}</th>
          <th scope="col" nzWidth="160px" [testId]="'header-update-time'">{{ 'theme.list.table.update-time' | i18n }}</th>

          <th scope="col" nzRight nzWidth="200px" [testId]="'header-actions'">{{ 'common.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody [testId]="'table-body'">
        <tr *ngFor="let item of listOfData; let i = index" [testId]="'data-row-' + i">
          <td nzLeft class="text-center row-number-column" [testId]="'cell-serial-number-' + i">{{ i + 1 }}</td>
          <td [testId]="'cell-name-' + i">
            <span class="truncate-text" nz-tooltip [nzTooltipTitle]="item.name" [testId]="'name-span-' + i">{{ item.name }}</span>
          </td>
          <td [testId]="'cell-description-' + i">
            <span class="truncate-text" nz-tooltip [nzTooltipTitle]="item.description" [testId]="'description-span-' + i">{{
              item.description
            }}</span>
          </td>
          <td [testId]="'cell-status-' + i">
            <nz-tag [nzColor]="getStatusColor(item.status)" [testId]="'status-tag-' + i">{{ getStatusI18nKey(item.status) | i18n }}</nz-tag>
          </td>
          <td [testId]="'cell-update-time-' + i">
            <span class="truncate-text" [testId]="'update-time-span-' + i">{{ item.updateTime | date: 'yyyy-MM-dd HH:mm' }}</span>
          </td>

          <td nzRight [testId]="'cell-actions-' + i">
            <button
              *ngIf="!selectMode"
              nz-button
              nzType="default"
              nzShape="circle"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="(item.isDefault ? 'theme.item.default-theme' : 'theme.item.set-default') | i18n"
              class="action-button default-button"
              (click)="setDefaultTheme(item)"
              [disabled]="loading || item.isDefault"
              [testId]="'theme-list-set-default-button-' + i"
            >
              <nz-icon
                nzType="star"
                [nzTheme]="item.isDefault ? 'fill' : 'outline'"
                [style.color]="item.isDefault ? '#faad14' : null"
                [testId]="'theme-list-set-default-icon-' + i"
              />
            </button>
            <button
              *ngIf="!selectMode"
              nz-button
              nzType="primary"
              nzShape="circle"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'common.edit' | i18n"
              class="action-button edit-button"
              (click)="goToEdit(item)"
              [testId]="'theme-list-edit-button-' + i"
            >
              <nz-icon nzType="edit" nzTheme="outline" [testId]="'theme-list-edit-icon-' + i" />
            </button>

            <button
              *ngIf="!selectMode && shouldShowEnableButton(item)"
              nz-button
              nzType="primary"
              nzShape="circle"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'theme.status.enable' | i18n"
              class="action-button enable-button"
              (click)="enableTheme(item)"
              [disabled]="loading"
              [testId]="'theme-list-enable-button-' + i"
            >
              <nz-icon nzType="check-circle" nzTheme="outline" [testId]="'theme-list-enable-icon-' + i" />
            </button>

            <button
              nz-button
              nzType="default"
              nzShape="circle"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'theme.list.action.preview' | i18n"
              class="action-button preview-button"
              (click)="openPreview(item, i)"
              [testId]="'theme-list-preview-button-' + i"
            >
              <nz-icon nzType="eye" nzTheme="outline" [testId]="'theme-list-preview-icon-' + i" />
            </button>

            <ng-container *ngIf="!selectMode">
              <button
                *ngIf="shouldShowDisableButton(item)"
                nz-button
                nzType="default"
                nzDanger
                nzShape="circle"
                nzSize="small"
                nz-tooltip
                [nzTooltipTitle]="'theme.status.disable' | i18n"
                class="action-button disable-button"
                (click)="disableTheme(item)"
                [disabled]="loading"
                [testId]="'theme-list-disable-button-' + i"
              >
                <nz-icon nzType="close-circle" nzTheme="outline" [testId]="'theme-list-disable-icon-' + i" />
              </button>

              <button
                nz-button
                nzType="default"
                nzDanger
                nzShape="circle"
                nzSize="small"
                nz-tooltip
                [nzTooltipTitle]="'common.delete' | i18n"
                class="action-button delete-button"
                (click)="deleteTheme(item)"
                [testId]="'theme-list-delete-button-' + i"
              >
                <nz-icon nzType="delete" nzTheme="outline" [testId]="'theme-list-delete-icon-' + i" />
              </button>
            </ng-container>
            <button
              *ngIf="selectMode"
              nz-button
              nzType="primary"
              nzSize="small"
              class="action-button select-button"
              (click)="onSelect(item)"
              [testId]="'theme-list-select-button-' + i"
            >
              {{ 'theme.list.action.select' | i18n }}
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <!-- 預覽模態框：內容與詳情頁一致 -->
  <nz-modal
    [(nzVisible)]="previewVisible"
    [nzTitle]="previewTitle"
    [nzFooter]="previewFooter"
    (nzOnCancel)="closePreview()"
    testId="theme-list-preview-modal"
  >
    <ng-template #previewTitle>
      <div class="preview-header-bar">
        <div class="title-left">
          <span class="modal-title">{{ 'theme.item.preview.title' | i18n }}</span>
          <span class="theme-name" *ngIf="previewItem?.name">— {{ previewItem?.name }}</span>
        </div>
        <button
          *ngIf="previewItem?.id && !selectMode"
          nz-button
          nzType="link"
          nz-tooltip
          [nzTooltipTitle]="'common.edit' | i18n"
          (click)="goToEdit(previewItem!)"
          testId="theme-list-preview-edit-button"
        >
          <nz-icon nzType="edit" nzTheme="outline" />
          <span class="button-text">{{ 'common.edit' | i18n }}</span>
        </button>
      </div>
    </ng-template>
    <ng-container *nzModalContent>
      <div
        class="chat-preview"
        [ngStyle]="{
          background: previewConfig.backgroundColor,
          boxShadow: previewConfig.boxShadow.medium,
          borderRadius: previewConfig.windowRadius
        }"
      >
        <div class="chat-header" [ngStyle]="{ background: previewConfig.headerBg, color: previewConfig.headerTextColor }">
          <span class="title">{{ 'theme.item.preview.header' | i18n }}</span>
        </div>
        <div class="chat-messages">
          <div
            class="message service"
            [ngStyle]="{
              background: previewConfig.agentBubbleBg,
              color: previewConfig.agentBubbleText,
              borderRadius: previewConfig.bubbleRadius,
              boxShadow: previewConfig.boxShadow.medium,
              fontSize: previewConfig.fontSize.base
            }"
          >
            {{ 'theme.item.preview.service-message.example' | i18n }}
          </div>
          <div
            class="message user"
            [ngStyle]="{
              background: previewConfig.customerBubbleBg,
              color: previewConfig.customerBubbleText,
              borderRadius: previewConfig.bubbleRadius,
              boxShadow: previewConfig.boxShadow.medium,
              fontSize: previewConfig.fontSize.base
            }"
          >
            {{ 'theme.item.preview.user-message.example' | i18n }}
          </div>
        </div>
        <div class="chat-input" [ngStyle]="{ background: previewConfig.footerBg }">
          <input nz-input [placeholder]="'theme.item.preview.input-placeholder' | i18n" testId="theme-list-preview-input" />
          <button
            nz-button
            nzType="primary"
            [style.background-color]="previewConfig.primaryColor"
            [style.border-color]="previewConfig.primaryColor"
            testId="theme-list-preview-send-button"
          >
            {{ 'theme.item.preview.send' | i18n }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #previewFooter>
      <button nz-button nzType="default" (click)="previewPrev()" [disabled]="!canPrev()" testId="theme-list-preview-prev-button">
        {{ 'theme.list.action.prev' | i18n }}
      </button>
      <button nz-button nzType="default" (click)="previewNext()" [disabled]="!canNext()" testId="theme-list-preview-next-button">
        {{ 'theme.list.action.next' | i18n }}
      </button>
    </ng-template>
  </nz-modal>

  <div class="pagination-section" *ngIf="total > 0" [testId]="'pagination-container'">
    <div class="pagination-info" [testId]="'pagination-info'">{{ 'common.total-records' | i18n: { total: total } }}</div>
    <div class="pagination-controls">
      <nz-pagination
        [testId]="'pagination'"
        nzSize="small"
        [nzShowQuickJumper]="true"
        [nzPageIndex]="pageIndex"
        [nzTotal]="total"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      />
    </div>
  </div>
</div>
